import { PayloadAction } from "@reduxjs/toolkit";

import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  ICreateProductRequest,
  IErrorResponse,
  IGetByIdRequest,
  IPaginationRequest,
  IUpdateProductRequest,
  ICreateProductResponse,
  IDeleteProductResponse,
  IGetAllProductResponse,
  IGetProductByIdResponse,
  IUpdateProductResponse,
  IApiResponse,
  IUpdateProductPackingRequest,
} from "model";
import { call, put, takeEvery } from "redux-saga/effects";
import { ProductActions } from "redux/actions";
import { ProductApiService } from "services";

function* getAllProducts(action: PayloadAction<IPaginationRequest>) {
  try {
    const result: IGetAllProductResponse = yield call(
      ProductApiService.getAllProducts,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductActions.getAllProducts.success(result));
    } else {
      const error = result as IErrorResponse;
      yield put(ProductActions.getAllProducts.failed(error));
    }
  } catch (error) {
    yield put(ProductActions.getAllProducts.failed(error));
  }
}
function* getProductById(action: PayloadAction<IGetByIdRequest>) {
  try {
    const result: IGetProductByIdResponse = yield call(
      ProductApiService.getProductById,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductActions.getProductById.success(result.data!));
    } else {
      const error = result as IErrorResponse;
      yield put(ProductActions.getProductById.failed(error));
    }
  } catch (error) {
    yield put(ProductActions.getProductById.failed(error));
  }
}

function* createProduct(action: PayloadAction<ICreateProductRequest>) {
  try {
    const result: ICreateProductResponse = yield call(
      ProductApiService.createProduct,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductActions.createProduct.success(result.data!));
      AlertHelper.showAlert("Create Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ProductActions.createProduct.failed(error));
    }
  } catch (error) {
    yield put(ProductActions.createProduct.failed(error));
  }
}

function* updateProduct(action: PayloadAction<IUpdateProductRequest>) {
  try {
    const result: IUpdateProductResponse = yield call(
      ProductApiService.updateProduct,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductActions.updateProduct.success(result.data!));
      AlertHelper.showAlert("Update Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ProductActions.updateProduct.failed(error));
    }
  } catch (error) {
    yield put(ProductActions.updateProduct.failed(error));
  }
}

function* updateProductPacking(
  action: PayloadAction<IUpdateProductPackingRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      ProductApiService.updateProductPacking,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductActions.updateProductPacking.success(result.data!));
    } else {
      const error = result as IErrorResponse;
      yield put(ProductActions.updateProductPacking.failed(error));
    }
  } catch (error) {
    yield put(ProductActions.updateProductPacking.failed(error));
  }
}

function* deleteProduct(action: PayloadAction<{ id: string }>) {
  try {
    const result: IDeleteProductResponse = yield call(
      ProductApiService.deleteProduct,
      action.payload
    );
    if (result.succeeded) {
      yield put(ProductActions.deleteProduct.success(result.data!));
      AlertHelper.showAlert("Delete Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(ProductActions.deleteProduct.failed(error));
    }
  } catch (error) {
    yield put(ProductActions.deleteProduct.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(ProductActions.getAllProducts.request, getAllProducts);
  yield takeEvery(ProductActions.getProductById.request, getProductById);
  yield takeEvery(ProductActions.createProduct.request, createProduct);
  yield takeEvery(ProductActions.updateProduct.request, updateProduct);
  yield takeEvery(ProductActions.deleteProduct.request, deleteProduct);
  yield takeEvery(
    ProductActions.updateProductPacking.request,
    updateProductPacking
  );
}
